var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57549 4.21904C2.74905 4.04548 3.03046 4.04548 3.20403 4.21904L6.00087 7.01588L8.79771 4.21904C8.97128 4.04548 9.25268 4.04548 9.42625 4.21904C9.59981 4.39261 9.59981 4.67401 9.42625 4.84758L6.31514 7.95869C6.14157 8.13226 5.86016 8.13226 5.6866 7.95869L2.57549 4.84758C2.40192 4.67401 2.40192 4.39261 2.57549 4.21904Z",
    fill: "#3C6CD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDown);
export default __webpack_public_path__ + "static/media/ic-chevron-down.6c4f5411af15fd443833eff20ec16333.svg";
export { ForwardRef as ReactComponent };